import { UtilitiesCourseProgressDto } from '../generated-types/utilitiesCourseProgressDto';
import { UtilitiesUserSearchDto } from '../generated-types/utilitiesUserSearchDto';
import { AbstractApi } from './AbstractApi';

/**
 * An api class to interact with the utilities controller
 */
export default class UtilitiesApi extends AbstractApi {
  /**
   * Get the users for the search component
   * @returns The users
   */
  async GetUsers(): Promise<UtilitiesUserSearchDto[]> {
    const response = await this.authFetch(this.BuildUrl('utilities/users'), {
      method: 'GET',
    });

    if (!response.ok) throw Error();

    return response.json() as unknown as UtilitiesUserSearchDto[];
  }

  /**
   * Get the course progress for a user
   * @param userId The id of the user to get the course progress for
   */
  async GetUserCourseProgress(
    userId: string
  ): Promise<UtilitiesCourseProgressDto> {
    const response = await this.authFetch(
      this.BuildUrl(`utilities/users/${userId}/course-progress`),
      {
        method: 'GET',
      }
    );

    if (!response.ok) throw Error();

    return response.json() as unknown as UtilitiesCourseProgressDto;
  }

  /**
   * Save the course progress for a user
   * @param userId The id of the user to save the course progress for
   * @param progress The updated course progress
   */
  async SaveCourseProgress(
    userId: string,
    progress: UtilitiesCourseProgressDto
  ) {
    const response = await this.authFetch(
      this.BuildUrl(`utilities/users/${userId}/course-progress`),
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(progress),
      }
    );

    if (!response.ok) throw Error();
  }

  /**
   * Delete the specified user
   * @param userId The id of the user to delete
   */
  async DeleteUser(userId: string) {
    const response = await this.authFetch(
      this.BuildUrl(`utilities/users/${userId}`),
      {
        method: 'DELETE',
      }
    );

    if (!response.ok) throw Error();
  }
}
